module.exports = __webpack_public_path__ + "static/media/gif3.51ff53fd.gif";